import { Injectable } from '@angular/core';
import { TodayTripStaticContent } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  checkStringValueNull,
  getAuxiliaryNavigation,
  HeaderFooterMachCore,
  TodayPanelAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { TODAY_PANEL } from '../../models/constants/common/common.constants';
import * as HelperMethods from '../../utils/todays-trip/flyout-today-trip-helper.utils';
import * as Methods from '../../utils/todays-trip/flyout-today-trip.utils';

@Injectable({
  providedIn: 'root'
})
export class FlyoutTodayLabelsAdapterService {
  getTripLabels(
    contentHeaderFooter: HeaderFooterMachCore
  ): TodayTripStaticContent {
    const todayPanelObject = getAuxiliaryNavigation(
      contentHeaderFooter,
      TODAY_PANEL
    ) as TodayPanelAem;
    return {
      remainOnFlightLabel: HelperMethods.toTitleCase(
        todayPanelObject.remainOnFlight
      ),
      viewTripDetailsLabel: HelperMethods.toTitleCase(
        todayPanelObject.viewTripDetails
      ),
      findAlternateLabel: HelperMethods.toTitleCase(
        todayPanelObject.findAlternate
      ),
      operatedByLabel: checkStringValueNull(todayPanelObject.operatedby),
      departLabel: checkStringValueNull(todayPanelObject.depart),
      wasLabel: checkStringValueNull(todayPanelObject.was),
      arriveLabel: checkStringValueNull(todayPanelObject.arrive),
      viewBoardingPassLabel: checkStringValueNull(
        todayPanelObject.viewBoardingPass
      ),
      checkInLabel: checkStringValueNull(todayPanelObject.checkinLabel),
      statusLabel: HelperMethods.toTitleCase(todayPanelObject.statusLabel),
      gateLabel: HelperMethods.toTitleCase(todayPanelObject.gateLabel),
      seatLabel: HelperMethods.toTitleCase(todayPanelObject.seatLabel),
      bookFlightLinkLabel: checkStringValueNull(
        todayPanelObject.bookFlightLink
      ),
      myTripsLinkLabel: checkStringValueNull(todayPanelObject.myTripsLink),
      bookLabel: checkStringValueNull(
        Methods.getBookLabel(contentHeaderFooter)
      ),
      my_tripsLabel: checkStringValueNull(
        Methods.getMyTripsLabel(contentHeaderFooter)
      )
    };
  }
}
